export default function SolunarStatusIcon({ type = "overhead", size = 11 }) {
  const isOverhead = type === "overhead";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: "inline-block", marginLeft: 4, verticalAlign: "middle" }}
    >
      {/* Background circle */}
      <circle cx="12" cy="12" r="10" stroke="#9db3c9" fill="none" />

      {/* Horizon line */}
      <line x1="2" y1="12" x2="22" y2="12" stroke="#9db3c9" strokeOpacity="0.4" />

      {/* Moon indicator */}
      {isOverhead ? (
        /* Moon above horizon (overhead) */
        <>
          <circle cx="12" cy="8" r="3" fill="#f2ead2" stroke="#1a2838" strokeWidth="0.5" />
          {/* Arrow down toward horizon */}
          <line x1="12" y1="11.5" x2="12" y2="15" stroke="#9db3c9" strokeOpacity="0.6" />
          <line x1="10" y1="13" x2="12" y2="15" stroke="#9db3c9" strokeOpacity="0.6" />
          <line x1="14" y1="13" x2="12" y2="15" stroke="#9db3c9" strokeOpacity="0.6" />
        </>
      ) : (
        /* Moon below horizon (underfoot) */
        <>
          <circle cx="12" cy="16" r="3" fill="#f2ead2" stroke="#1a2838" strokeWidth="0.5" />
          {/* Arrow up toward horizon */}
          <line x1="12" y1="12.5" x2="12" y2="9" stroke="#9db3c9" strokeOpacity="0.6" />
          <line x1="10" y1="11" x2="12" y2="9" stroke="#9db3c9" strokeOpacity="0.6" />
          <line x1="14" y1="11" x2="12" y2="9" stroke="#9db3c9" strokeOpacity="0.6" />
        </>
      )}
    </svg>
  );
}
